import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { EnrollmentAcceptedStudentService } from 'src/app/service/enrollmentAcceptedStudent.service';
import { FileService } from 'src/app/service/file.service';
import { CoursesService } from 'src/app/service/courses.service';


import { environment } from 'src/environments/environment';
import { Console } from 'console';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { ThisReceiver } from '@angular/compiler';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: 'app-student-grouping',
  templateUrl: './student-grouping.component.html',
  styleUrls: ['./student-grouping.component.scss']
})
export class StudentGroupingComponent implements OnInit {

  select: any;
  showLoader: boolean = false;
  repeaterPage: boolean = false;
  searchByFields: any;
  students: any = [];
  table: any;
  years: any;
  semesters: any;
  batches: any;
  orgId: any;
  username: any;
  studentStatuses: any;
  subjectStates: any;
  batchCourses: any;
  studentCourses: any;
  studentCoursesBackup: any;
  studentupdateFail: any;
  studentsupdateSuccess: any;
  studentBatchCount: any;

  currentYear: any;
  currentSemester: any;
  currentBatch: any;
  currentStudentStatus: any;
  currentGender: any;
  currentAssignedStatus: any;

  currentStudentId: any;

  courses: any = [];
  throryGroups: any = [];
  clinicalGroups: any = [];

  clinicalFilteredGroups: any[][] = [];
  theoryFilteredGroups: any[][] = [];
  studentGroupStatus:any=[];

  studentCoursesModalLoader = false;
  searchForm = new FormGroup({
    year: new FormControl('', [
      Validators.required,
    ]),
    semester: new FormControl('', [
      Validators.required,
    ]),
    batch: new FormControl('', [
      Validators.required,
    ]),
    gender: new FormControl('ALL', [
      // Validators.required,
    ]),
    status: new FormControl('', [
      Validators.required,
    ]),
    statusAssign: new FormControl('ALL', [
      // Validators.required,
    ]),
  });

  theoryGroupForm = new FormGroup({
    arabicName: new FormControl('', [
      Validators.required,
    ]),
    englishName: new FormControl('', [
      Validators.required,
    ]),
    groupCode: new FormControl('', [
      Validators.required,
    ]),
    type: new FormControl('', [
      Validators.required,
    ]),
  });

  theoryGroupStatus = new FormGroup({
    status: new FormControl('', [
      Validators.required,
    ]),
  });

  assignGroupProccessedForm = new FormGroup({

    type: new FormControl('', [
     Validators.required,
    ]),
    // thGroup: new FormControl('', [
    //   Validators.required,
    // ]),
    // clGroup: new FormControl('', [
    // //  Validators.required,
    // ]),

  });
  assignGroupRepeaterForm = new FormGroup({

    englishName: new FormControl('', [
      // Validators.required,
    ]),
    thGroup: new FormControl('', [
      // Validators.required,
    ]),
    clGroup: new FormControl('', [
      //  Validators.required,
    ]),
    status: new FormControl('', [
      Validators.required,
    ]),

  });
  constructor(private toastrService: ToastrService, public enrollmentAcceptedStudentService: EnrollmentAcceptedStudentService, public globals: Globals, private router: Router, public translate: TranslateService, private fileService: FileService, private enrollmentGroupService: EnrollmentGroupService, private coursesService: CoursesService) { }

  ngOnInit(): void {
    this.orgId = this.globals.currentUserInfo.orgid;
    this.username = this.globals.currentUserInfo.username;

    this.getALLCLNCGroups();
    this.getALLTHEOGroups();
    this.getYears();
    // this.getBatches();
    this.getStudentStatuses();
    this.getSubjectStatues();
    // this.throryGroups=[{
    //   id:1,
    //   name:"TH-GROUP-1"
    // },
    // {
    //   id:2,
    //   name:"TH-GROUP-2"
    // },{
    //   id:3,
    //   name:"TH-GROUP-3"
    // }];
    // this.clinicalGroups=[{
    //   id:1,
    //   name:"CL-GROUP-1"
    // },
    // {
    //   id:2,
    //   name:"CL-GROUP-2"
    // },{
    //   id:3,
    //   name:"CL-GROUP-3"
    // }];
    // this.students = [
    //   {
    //     matNo: 1002,
    //     studentNameAR: "محمود رضا",
    //     studentNameEN: "Mahmoud reda",
    //     status: "Proccessed",
    //     gender: "Male",
    //     assignGroupStatus: "done",
    //     clinGroup: 2
    //   },
    //   {
    //     matNo: 1003,
    //     studentNameAR: "مروان حمدى",
    //     studentNameEN: "Mahmoud reda shabaan",
    //     status: "Repeater",
    //     gender: "Male",
    //     assignGroupStatus: "In Progress",
    //     clinGroup: 3
    //   },
    // ];

    // this.courses = [
    //   {
    //     id: 1,
    //     subjectCode: 'c01',
    //     subjectNameAr: 'عربي',
    //     subjectNameEn: 'english',
    //     classHours: '15',
    //     practicalHours: '3',
    //     totalHours: '18',
    //     creditHours: '2',
    //     minClassHours: '6',
    //     minPracticalHours: '3',
    //     active: 'YES'
    //   },
    //   {
    //     id: 2,
    //     subjectCode: 'c02',
    //     subjectNameAr: 'عربي',
    //     subjectNameEn: 'english',
    //     classHours: '20',
    //     practicalHours: '5',
    //     totalHours: '12',
    //     creditHours: '5',
    //     minClassHours: '11',
    //     minPracticalHours: '7',
    //     active: 'NO'
    //   }
    // ];
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
      //this.initFormDropDownsFields();
    });
  }

  updateTable() {
    // if(this.table)
    // {
    //   this.table.destroy();
    // }else{$("#datatable").DataTable().destroy();}
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      this.table = $("#datatable").DataTable({
        columnDefs: [{
          orderable: false,
          className: 'select-checkbox',
          targets: 0
        }],
        select: {
          style: 'multi',
          selector: 'td:first-child',
          blurable: false
        },
        // select: true,
        // dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // rowReorder: true,
        // "columnDefs": [
        //   { orderable: true, className: 'reorder', targets: [0] },
        //   { orderable: false, targets: '_all' }
        // ],
        // pageLength: 5,
        paging: false,
        searching: false,
        ordering: false,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        // buttons: [{
        //   extend: 'excelHtml5',
        //   text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
        //   titleAttr: 'EXCEL',
        //   exportOptions: {
        //     columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
        //   },
        //   className: 'datatable_custom_buttons',
        // }],
      }).on('select.dt deselect.dt', (e: any) => {
        let numberOfRecords = this.table.rows().nodes().length;
        let selectedRows = this.table.rows(".selected").nodes().length;

        if (numberOfRecords === selectedRows)
          $(".select-all").prop("checked", true);
        else
          $(".select-all").prop("checked", false);

        this.table.button(0).enable(selectedRows > 0);
        this.table.button(1).enable(selectedRows === 1);
        this.table.button(2).enable(selectedRows === 1);
      });;

      $('#datatable').on('click', '.select-all', (e: any) => {
        if (e.target.checked)
          this.table.rows().select();
        else
          this.table.rows().deselect();
      });

      let dataTableButtonsDiv = <HTMLElement>document.getElementsByClassName('dt-buttons')[0];
      if (dataTableButtonsDiv != null) {
        dataTableButtonsDiv.style.padding = '0px 15px 0px 15px';
      }

      // Test datatable function start
      // console.log(table.rows({ search: 'applied', order: 'applied' }).data());
      // table.on('row-reordered', function (e: any, details: any, edit: any) {
      // console.log(table.rows({order:'current'}).data());
      // console.log('row-reordered');
      // console.log(table.rows().data());
      // var indexes = table.rows().indexes().toArray();
      // for (var r = 0; r < indexes.length; r++) {
      //   //get row data
      //   var data = table.row(indexes[r]).data();
      //   console.log(data);
      // }
      // });
      // Test datatable function end

    }, 1);

  }

  searchFormChange() {
  }

  searchFormSubmit() {
    if (this.searchForm.valid) {
      this.currentYear = this.searchForm.controls.year.value;
      this.currentSemester = this.searchForm.controls.semester.value;
      this.currentBatch = this.searchForm.controls.batch.value;
      this.currentGender = this.searchForm.controls.gender.value;
      this.currentStudentStatus = this.searchForm.controls.status.value;
      this.currentAssignedStatus = this.searchForm.controls.statusAssign.value

      this.enrollmentGroupService.getErlStudentsByGradeGenderStatusAssign(this.orgId, this.currentYear, this.currentSemester, this.currentBatch, this.currentStudentStatus, this.currentGender, this.currentAssignedStatus)
        .subscribe(
          data => {
            if (data) {
              this.students = data;
              this.getBatchCourses();
              // TODO MUST ACTIVE BELOW CODE
              if (this.currentStudentStatus==30) {
                this.repeaterPage=true;
              } else {
                this.repeaterPage=false;
              }
            } else {
              this.repeaterPage = false;
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_STUDENT_SUBJECTS_BE'));
          },
          () => this.updateTable()
        );
    } else {
      this.searchForm.markAllAsTouched();
      this.searchForm.markAsDirty();
    }
  }

  test() {
    console.log(this.table.rows({ selected: true }).data().toArray());
    // let currentDatatableRows = this.table.rows({ select: 'current' }).data().toArray();
    //.rows({ select: 'current' }).data().toArray()
  }

  theoryGroupFormSubmit(FormData: any) {
    if (this.theoryGroupForm.valid) {
      console.log('add new theory group');
      console.log(FormData);
      let egroupCode = this.theoryGroupForm.controls.groupCode.value;
      let egroupNameAr = this.theoryGroupForm.controls.arabicName.value;
      let egroupNameEn = this.theoryGroupForm.controls.englishName.value;
      let egroupType = this.theoryGroupForm.controls.type.value;
      this.addNewGroup(egroupCode, egroupNameAr, egroupNameEn, egroupType);
      $('#close-EditAcceptCand2').click();
    } else {
      this.theoryGroupForm.markAllAsTouched();
      this.theoryGroupForm.markAsDirty();
    }

  }

  assignGroupProccessedFormSubmit(FormData: any) {
    if (this.assignGroupProccessedForm.valid) {
      console.log(this.table.rows({ selected: true }).data().toArray());
      let selectedStudents = this.table.rows({ selected: true }).data().toArray();

      if (selectedStudents.length > 0) {
        this.studentsupdateSuccess = 0;
        this.studentupdateFail = 0;
        this.studentBatchCount = selectedStudents.length;
        console.log(this.studentBatchCount);
        this.showLoader = true;
        selectedStudents.forEach((stud: any) => {
          let studentId = stud["1"];
          if (studentId > 0) {
            let typeOfAssign=this.assignGroupProccessedForm.controls.type.value;
            console.log(typeOfAssign);
            if(typeOfAssign=="all"){
              console.log("choose all");
            this.updateStudentSubjects(studentId);
            }else if(typeOfAssign=="theory"){
              console.log("choose theory");
              this.updateStudentTheorySubjects(studentId);

            }else if(typeOfAssign=="clincal"){
              this.updateStudentClincSubjects(studentId);
              console.log("choose clincal");

            }
          }
        });
      } else {
        this.toastrService.warning(this.translate.instant('PLEASE_SELECT_STUDENT'));
      }

      $('#close-EditAcceptCand1').click();
    } else {
      this.assignGroupProccessedForm.markAllAsTouched();
      this.assignGroupProccessedForm.markAsDirty();
    }

  }
  assignGroupRepeaterModalFormSubmit(FormData: any) {
    if (this.assignGroupRepeaterForm.valid) {
      if(this.currentStudentId > 0)
      {
        this.studentsupdateSuccess = 0;
        this.studentupdateFail = 0;

        this.showLoader = true;
        this.updateStudentSubjectsSingle(this.currentStudentId);
      }else{
        this.toastrService.warning(this.translate.instant("PLEASE_SELECT_STUDENT"));
      }
      $('#close-EditAcceptCand').click();
    } else {
      this.assignGroupRepeaterForm.markAllAsTouched();
      this.assignGroupRepeaterForm.markAsDirty();
    }
  }

  assignGroupRepeater(studId: any) {
    this.studentCourses = [];
    this.assignGroupRepeaterForm.controls = {};
    this.currentStudentId = studId;
    this.enrollmentAcceptedStudentService.getStudentRepeaterSubjects(this.orgId, this.currentYear, this.currentSemester, studId).subscribe(
        data => {
          let studentSubjects = data;
          this.studentCourses = studentSubjects.map((course: any) => {
            // let courseValues = studentCoursesValues.filter((courseValue: any) => courseValue.subjectid == course.subjectid)[0];

            let statusValue = "";
            let thryGroupValue = "";
            let clinGroupValue = "";
            let disableStatus = false;
            // if(courseValues)
            // {
              statusValue = course.subjectStatusid > 0 ? course.subjectStatusid : "";
              thryGroupValue = course.theoEgroupid > 0 ? course.theoEgroupid : "";
              clinGroupValue = course.clncEgroupid > 0 ? course.clncEgroupid : "";
              // For repeater subject
              if(course.subjectStatusid == 20)
              {
                disableStatus = true;
              }
            // }
            // console.log(disableStatus);
            let subjectStatusController = "";
            if (this.repeaterPage) {
              this.assignGroupRepeaterForm.addControl('subjectStatus_' + course.id, new FormControl(statusValue));
              subjectStatusController = 'subjectStatus_' + course.id;
            }
            this.assignGroupRepeaterForm.addControl('thGroup_' + course.id, new FormControl(thryGroupValue));
            // if (this.repeaterPage) {
            //   this.assignGroupRepeaterForm.addControl('thGroup_' + course.id, new FormControl(thryGroupValue));
            // } else {
            //   this.assignGroupRepeaterForm.addControl('thGroup_' + course.id, new FormControl(thryGroupValue, Validators.required));
            // }

            this.assignGroupRepeaterForm.addControl('clGroup_' + course.id, new FormControl(clinGroupValue));


            //fill theoArray filtered by each subject as per
            this.getTHEOGroupsBySubject(course.subjectid);
            //fill ClinicArray filtered by each subject as per
            this.getCLNCGroupsBySubject(course.subjectid);

            return { ...course, thGroupControllerName: 'thGroup_' + course.id, clGroupControllerName: 'clGroup_' + course.id, subjectStatusControllerName: subjectStatusController, disableStatus: disableStatus };
          });
          // console.log(this.studentCourses);
          $("#assignGroupRepeaterModal").modal('show');
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getALLTHEOGroups() {
    this.enrollmentGroupService.getGroupsByType("THEO", this.globals.orgId)
      .subscribe(
        data => {
          console.log(data);
          this.throryGroups = data;
          this.showLoader = false;

        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );



  }

  getALLCLNCGroups() {
    this.enrollmentGroupService.getGroupsByType("CLNC", this.globals.orgId)
      .subscribe(
        data => {
          console.log(data);
          this.clinicalGroups = data;
          this.showLoader = false;

        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );

  }

  addNewGroup(egroupCode: string, egroupNameAr: string, egroupNameEn: string, egroupType: string) {
    this.enrollmentGroupService.addGroup(this.globals.currentUserInfo.username, this.globals.orgId,
      egroupCode, egroupNameAr, egroupNameEn, egroupType, "YES")
      .subscribe(
        data => {
          console.log(data);
          //  this.clinicalGroups=data;
          this.getALLCLNCGroups();
          this.getALLTHEOGroups();
          this.showLoader = false;
          this.theoryGroupForm.controls.groupCode.setValue(null);
          this.theoryGroupForm.controls.arabicName.setValue(null);
          this.theoryGroupForm.controls.englishName.setValue(null);
          this.theoryGroupForm.controls.type.setValue(null);
          this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));


        },
        error => {
          this.showLoader = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );

  }

  assignGroupProccessedFormIsTouched(formControlName: string): boolean {
    return this.assignGroupProccessedForm.get(formControlName)?.touched ? true : false;
  }

  assignGroupProccessedFormIsInvalid(formControlName: string): boolean {
    return this.assignGroupProccessedForm.get(formControlName)?.invalid ? true : false;
  }

  assignGroupRepeaterFormIsTouched(formControlName: string): boolean {
    return this.assignGroupRepeaterForm.get(formControlName)?.touched ? true : false;
  }

  assignGroupRepeaterFormIsInvalid(formControlName: string): boolean {
    return this.assignGroupRepeaterForm.get(formControlName)?.invalid ? true : false;
  }
  getYears() {
    this.enrollmentGroupService.getYears()
      .subscribe(
        data => {
          this.years = data;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getYearSemesters() {
    let year = this.searchForm.controls.year.value;
    if (year) {
      this.enrollmentGroupService.getYearSemesters(year)
        .subscribe(
          data => {
            this.semesters = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.semester.reset();
      this.semesters = [];
    }
  }

  getBatches() {
    let year = this.searchForm.controls.year.value;
    let semester = this.searchForm.controls.semester.value;
    if (year && semester) {
      this.enrollmentGroupService.getSemesterBatches(this.orgId, year, semester)
        .subscribe(
          data => {
            this.batches = data;
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    } else {
      this.searchForm.controls.batch.reset();
      this.batches = [];
    }
  }

  getStudentStatuses() {
    this.enrollmentAcceptedStudentService.getStudentStatuses()
      .subscribe(
        data => {
          if (data) {
            // this.studentStatuses = data.filter((status: any) => (status.id == 10 || status.id == 20 || status.id == 30));
            this.studentStatuses = data;
          } else {
            this.studentStatuses = [];
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getSubjectStatues() {
    this.enrollmentAcceptedStudentService.getAllEelStudentStatus()
      .subscribe(
        data => {
          if (data) {
            this.subjectStates = data.filter((status: any) => (status.id == 20 || status.id == 40));
          } else {
            this.subjectStates = [];
          }
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  getBatchCourses() {
    let batchId = this.currentBatch;
    if (batchId > 0) {
      this.enrollmentGroupService.getBatchSubjects(this.orgId, batchId)
        .subscribe(
          data => {
            this.batchCourses = data.map((course: any) => {
              this.assignGroupProccessedForm.addControl('thGroup_' + course.id, new FormControl(""));
              // this.assignGroupProccessedForm.addControl('thGroup_' + course.id, new FormControl("", Validators.required));
              this.assignGroupProccessedForm.addControl('clGroup_' + course.id, new FormControl(""));

              //fill theoArray filtered by each subject as per
              this.getTHEOGroupsBySubject(course.subjectid);
              //fill ClinicArray filtered by each subject as per
              this.getCLNCGroupsBySubject(course.subjectid);

              return { ...course, thGroupControllerName: 'thGroup_' + course.id, clGroupControllerName: 'clGroup_' + course.id };
            });
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          }
        );
    }
  }
  
  updateStudentTheorySubjects(studId: number) {
    let bulkApis = this.batchCourses.map((course: any) => {
      let thryGroupId = this.assignGroupProccessedForm.get(course.thGroupControllerName)?.value;
      //let cliGroupId = this.assignGroupProccessedForm.get(course.clGroupControllerName)?.value;
    //  cliGroupId = (cliGroupId > 0)? cliGroupId : 0;
      thryGroupId = (thryGroupId > 0)? thryGroupId : 0;

      let studSubjectObj = {
        id: 0,
        ssstatusid: 10, // Status progress as default value
        theoEgroupid: thryGroupId,
      //  clncEgroupid: cliGroupId,
      };
      return this.enrollmentGroupService.updateStudentTheorySubjects(this.username, this.orgId, this.currentYear, this.currentSemester, studId, course.subjectid, studSubjectObj).pipe(map(res => res), catchError(e => of('Oops!')));
    });

    forkJoin(bulkApis).subscribe(
      data => {
        let subjectupdateFail = 0;
        let subjectsupdateSuccess = 0;
        data.forEach((msg: any) => {
          if (msg.sts == 'SUCCESS') {
            subjectsupdateSuccess++;
          } else {
            subjectupdateFail++;
          }
        });

        if (subjectupdateFail > 0) {
          this.studentupdateFail++;
        } else {
          this.studentsupdateSuccess++;
        }
        this.studentBatchCount --;
        if (this.studentBatchCount == 0) {
          
          this.toastrService.info(this.translate.instant("SUCCESS") + " (" + this.studentsupdateSuccess + ") " + this.translate.instant("FAIL") + " (" + this.studentupdateFail + ").");

          // Reload table
          this.searchFormSubmit();
          this.showLoader = false;
        }

        
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
        if (this.studentBatchCount < 1) {
          // Reload table
          this.searchFormSubmit();
          this.showLoader = false;
        }
      }
    );

  }
  updateStudentClincSubjects(studId: number) {
    let bulkApis = this.batchCourses.map((course: any) => {
     // let thryGroupId = this.assignGroupProccessedForm.get(course.thGroupControllerName)?.value;
      let cliGroupId = this.assignGroupProccessedForm.get(course.clGroupControllerName)?.value;
      cliGroupId = (cliGroupId > 0)? cliGroupId : 0;
     // thryGroupId = (thryGroupId > 0)? thryGroupId : 0;

      let studSubjectObj = {
        id: 0,
        ssstatusid: 10, // Status progress as default value
       // theoEgroupid: thryGroupId,
        clncEgroupid: cliGroupId,
      };
      return this.enrollmentGroupService.updateStudentClincSubjects(this.username, this.orgId, this.currentYear, this.currentSemester, studId, course.subjectid, studSubjectObj).pipe(map(res => res), catchError(e => of('Oops!')));
    });

    forkJoin(bulkApis).subscribe(
      data => {
        let subjectupdateFail = 0;
        let subjectsupdateSuccess = 0;
        data.forEach((msg: any) => {
          if (msg.sts == 'SUCCESS') {
            subjectsupdateSuccess++;
          } else {
            subjectupdateFail++;
          }
        });

        if (subjectupdateFail > 0) {
          this.studentupdateFail++;
        } else {
          this.studentsupdateSuccess++;
        }
        this.studentBatchCount --;
        if (this.studentBatchCount == 0) {
          
          this.toastrService.info(this.translate.instant("SUCCESS") + " (" + this.studentsupdateSuccess + ") " + this.translate.instant("FAIL") + " (" + this.studentupdateFail + ").");

          // Reload table
          this.searchFormSubmit();
          this.showLoader = false;
        }

        
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
        if (this.studentBatchCount < 1) {
          // Reload table
          this.searchFormSubmit();
          this.showLoader = false;
        }
      }
    );

  }
  updateStudentSubjects(studId: number) {
    let bulkApis = this.batchCourses.map((course: any) => {
      let thryGroupId = this.assignGroupProccessedForm.get(course.thGroupControllerName)?.value;
      let cliGroupId = this.assignGroupProccessedForm.get(course.clGroupControllerName)?.value;
      cliGroupId = (cliGroupId > 0)? cliGroupId : 0;
      thryGroupId = (thryGroupId > 0)? thryGroupId : 0;

      let studSubjectObj = {
        id: 0,
        ssstatusid: 10, // Status progress as default value
        theoEgroupid: thryGroupId,
        clncEgroupid: cliGroupId,
      };
      return this.enrollmentGroupService.updateStudentSubjects(this.username, this.orgId, this.currentYear, this.currentSemester, studId, course.subjectid, studSubjectObj).pipe(map(res => res), catchError(e => of('Oops!')));
    });

    forkJoin(bulkApis).subscribe(
      data => {
        let subjectupdateFail = 0;
        let subjectsupdateSuccess = 0;
        data.forEach((msg: any) => {
          if (msg.sts == 'SUCCESS') {
            subjectsupdateSuccess++;
          } else {
            subjectupdateFail++;
          }
        });

        if (subjectupdateFail > 0) {
          this.studentupdateFail++;
        } else {
          this.studentsupdateSuccess++;
        }
        this.studentBatchCount --;
        console.log(this.studentBatchCount);
        if (this.studentBatchCount == 0) {
          
          this.toastrService.info(this.translate.instant("SUCCESS") + " (" + this.studentsupdateSuccess + ") " + this.translate.instant("FAIL") + " (" + this.studentupdateFail + ").");

          // Reload table
          this.searchFormSubmit();
          this.showLoader = false;
        }

        
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
        if (this.studentBatchCount < 1) {
          // Reload table
          this.searchFormSubmit();
          this.showLoader = false;
        }
      }
    );

  }
  updateStudentSubjectsSingle(studId: number) {
    let bulkApis = this.studentCourses.map((course: any) => {
      let thryGroupId = this.assignGroupRepeaterForm.get(course.thGroupControllerName)?.value;
      let cliGroupId = this.assignGroupRepeaterForm.get(course.clGroupControllerName)?.value;
      let SubjectStatusId = this.assignGroupRepeaterForm.get(course.subjectStatusControllerName)?.value;
      cliGroupId = (cliGroupId > 0)? cliGroupId : 0;
      thryGroupId = (thryGroupId > 0)? thryGroupId : 0;
      SubjectStatusId = (SubjectStatusId > 0)? SubjectStatusId : 0;

      if(!this.repeaterPage){
        SubjectStatusId = 10;
      }else if(course.subjectStatusid == 20){
        SubjectStatusId = 20;
      }

      let studSubjectObj = {
        id: 0,
        ssstatusid: SubjectStatusId,
        theoEgroupid: thryGroupId,
        clncEgroupid: cliGroupId,
      };
      return this.enrollmentGroupService.updateStudentSubjects(this.username, this.orgId, this.currentYear, this.currentSemester, studId, course.subjectid, studSubjectObj).pipe(map(res => res), catchError(e => of('Oops!')));
    });

    forkJoin(bulkApis).subscribe(
      data => {
        let subjectupdateFail = 0;
        let subjectsupdateSuccess = 0;
        data.forEach((msg: any) => {
          if (msg.sts == 'SUCCESS') {
            subjectsupdateSuccess++;
          } else {
            subjectupdateFail++;
          }
        });

        if (subjectupdateFail > 0) {
          this.studentupdateFail++;
        } else {
          this.studentsupdateSuccess++;
        }
          this.toastrService.info(this.translate.instant("SUCCESS") + " (" + this.studentsupdateSuccess + ") " + this.translate.instant("FAIL") + " (" + this.studentupdateFail + ").");

          // Reload table
          this.searchFormSubmit();
          this.showLoader = false;

        
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_UPDATE"));
        if (this.studentBatchCount < 1) {
          // Reload table
          this.searchFormSubmit();
          this.showLoader = false;
        }
      }
    );

  }
  getTHEOGroupsBySubject(subjectId: any) {
    // return this.throryGroups;
    // console.log('ssssss',subjectId);
    console.log(subjectId, this.globals.orgId, this.currentSemester);
    
    this.theoryFilteredGroups= [];
    this.enrollmentGroupService.getGroupsByTypeAndSubject(this.globals.orgId, this.currentSemester, subjectId, "THEO")
      .subscribe(
        data => {
          this.throryGroups = data;
          // console.log(data);
          this.showLoader = false;
          this.theoryFilteredGroups.push(data);
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
    // return [];    
  }

  getCLNCGroupsBySubject(subjectId: any) {
    // return this.throryGroups;
    // console.log('ssssss',subjectId);
    console.log(subjectId, this.globals.orgId, this.currentSemester);
    this.clinicalFilteredGroups=[];
    this.enrollmentGroupService.getGroupsByTypeAndSubject(this.globals.orgId, this.currentSemester, subjectId, "CLNC")
      .subscribe(
        data => {
          this.clinicalGroups = data;
          // console.log(data);
          this.showLoader = false;
          this.clinicalFilteredGroups.push(data);
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
    // return [];    
  }

  theoryGroupStatusFormIsTouched(formControlName: string): boolean {
    return this.theoryGroupStatus.get(formControlName)?.touched ? true : false;
  }


  getCurrentGroupStatus(studentId: any) {
    this.enrollmentGroupService.getstudentstatuses(this.globals.orgId, this.currentSemester, studentId)
      .subscribe(
        data => {
          this.studentGroupStatus = data;
          this.currentStudentId=studentId;
          this.showLoader = false;
        },
        error => {
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }

  updatestudentstatus(studentId: any, sts: any) {
    console.log('inside updatestudentstatus');
    this.enrollmentGroupService.updatestudentstatus(this.globals.orgId, this.currentSemester, studentId, sts, this.username)
    .subscribe(data=>{
        this.showLoader = false;
        this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
      },
      error => {
        this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }

  theoryGroupStatusTagSubmit(){
    console.log('theoryGroupStatusTagSubmit');
    if (this.theoryGroupStatus.valid) {
      this.updatestudentstatus(this.currentStudentId,this.theoryGroupStatus.controls.status.value);
      this.showLoader = false;
      $('#close-EditAcceptCand3').click();
          // Reload table
        //   this.students.forEach((element:any,index:any)=>{
        //     if(element.studentid==this.currentStudentId) delete this.students[index];
        //  });
        //  this.updateTable();
        // this.searchFormSubmit();
        console.log(this.orgId, this.currentYear, this.currentSemester, this.currentBatch, this.currentStudentStatus, this.currentGender, this.currentAssignedStatus);
        this.enrollmentGroupService.getErlStudentsByGradeGenderStatusAssign(this.orgId, this.currentYear, this.currentSemester, this.currentBatch, this.currentStudentStatus, this.currentGender, this.currentAssignedStatus)
        .subscribe(
          data => {
            if (data) {
              this.students = data;
              this.getBatchCourses();
              // TODO MUST ACTIVE BELOW CODE
              if (this.currentStudentStatus==30) {
                this.repeaterPage=true;
              } else {
                this.repeaterPage=false;
              }
            } else {
              this.repeaterPage = false;
            }
          },
          error => {
            this.toastrService.error(this.translate.instant('CAN_NOT_GET_STUDENT_SUBJECTS_BE'));
          },
          () => this.updateTable()
        );

    } else {
      this.theoryGroupStatus.markAllAsTouched();
      this.theoryGroupStatus.markAsDirty();
    }
  }

}